import { createRoute } from "@tanstack/react-router";

import { requirePlatformAdmin } from "@platform/auth/guards";
import { shellRoute } from "@platform/shell.route";
import { AdminTenantsPage } from "./tenants.page";

export const adminTenantsRoute = createRoute({
	getParentRoute: () => shellRoute,
	path: "/admin/tenants",
	beforeLoad: ({ context }) => requirePlatformAdmin(context.queryClient),
	component: AdminTenantsPage,
});
